module.exports = __webpack_public_path__ + "static/media/90900-Inox.8e1fdff8.png";